export const formatedEventDay = ({
  clubTimeZone,
  eventStartDate,
}: {
  clubTimeZone: string;
  eventStartDate: string;
}): string => {
  const options: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    day: 'numeric',
    month: 'short',
    timeZone: clubTimeZone,
  };

  const formatter = new Intl.DateTimeFormat(
    'en-GB',
    options,
  );
  return formatter.format(
    new Date(eventStartDate),
  );
};

export const formatedGuestlistAndArrivalTime = ({
  eventName,
  arrivalTime,
  clubTimeZone,
}: {
  eventName: string;
  arrivalTime: string;
  clubTimeZone: string;
}): string => {
  const arrivalDate = new Date(arrivalTime);
  const options: Intl.DateTimeFormatOptions = {
    timeZone: clubTimeZone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };

  const formatter = new Intl.DateTimeFormat(
    'en-GB',
    options,
  );
  const formattedArrivalTime =
    formatter.format(arrivalDate);

  const formattedEventName = eventName.substring(
    '(Web) '.length,
    eventName.length,
  );
  return `${formattedEventName} ${formattedArrivalTime}`;
};
